import React, { Fragment, useState } from 'react';
import StatusModal from '../../status/StatusModal';
import { ApiNote } from '../../../api';
import QuickStatusComments from '../../../screening/alert/status/QuickStatusComments';
import RelatedAlertsStatusModal from '../../../screening/RelatedAlertsStatusModal';
import { useSelector } from 'react-redux';
import { AppState } from '../../../store/store';
import { InternalApiAlertType } from '../../../api-internal';
import { AlertInfo } from '../../../screening/alert/filters/ScreeningAlertFiltersResults';

interface Props {
  selectedAlerts: AlertInfo[];
  alertType: InternalApiAlertType;
  updateSanctionAlerts: (note: ApiNote, status: string) => void;
  onComplete: () => void;
}

export const BulkStatus = ({ selectedAlerts, alertType, updateSanctionAlerts, onComplete }: Props) => {
  const [showModal, setShowModal] = useState(false);
  const [processedAlertIndex, setProcessedAlertIndex] = useState(0);
  const [processRelatedAlerts, setProcessRelatedAlerts] = useState(false);
  const [note, setNote] = useState<ApiNote>();
  const [status, setStatus] = useState<string>();

  const { activeStatuses } = useSelector((state: AppState) => state.screeningAlertStatuses);

  const onSubmit = async (apiNote: ApiNote, selectedStatus: string) => {
    await updateSanctionAlerts(apiNote, selectedStatus);
    setNote(apiNote);
    setStatus(selectedStatus);
    setProcessedAlertIndex(0);
    setProcessRelatedAlerts(true);
  };

  const updateProcessedAlertIndex = () => {
    if (processedAlertIndex < selectedAlerts.length - 1) {
      setProcessedAlertIndex(processedAlertIndex + 1);
    } else {
      setProcessRelatedAlerts(false);
      onComplete();
    }
  };

  const onClose = () => {
    setShowModal(false);
  };

  return (
    <Fragment>
      <QuickStatusComments onSubmit={onSubmit} showModal={setShowModal} btnSize='medium' caption={'Set all statuses'} />
      <StatusModal
        showModal={showModal}
        onSubmit={onSubmit}
        onClose={onClose}
        alertType={alertType}
        selectedAlerts={selectedAlerts}
      />
      {processRelatedAlerts && note && status && (
        <RelatedAlertsStatusModal
          onComplete={updateProcessedAlertIndex}
          sanctionAlertId={selectedAlerts[processedAlertIndex].id}
          note={note.content}
          status={activeStatuses.find((it) => it.code === status)!}
        />
      )}
    </Fragment>
  );
};

export default BulkStatus;
